<template>
  <div
    id="passwordModal"
    class="modal fade auth-modal"
    tabindex="-1"
    aria-labelledby="passwordModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h2>Сменить пароль</h2>
          <button ref="closeButton" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form v-if="!text" class="mt-4" @submit.prevent="setPassword">
            <div class="mb-3">
              <label for="currentPassword" class="form-label">Старый пароль</label>
              <input
                id="currentPassword"
                v-model="user.current_password"
                type="password"
                class="form-control"
                autocomplete="current-password"
                required
              />
            </div>
            <div class="mb-3">
              <label for="newPassword" class="form-label">Новый пароль</label>
              <input
                id="newPassword"
                v-model="user.new_password"
                type="password"
                class="form-control"
                autocomplete="new-password"
                required
              />
            </div>
            <button type="submit" class="black-button mt-4">Сохранить</button>
          </form>
          <p v-else>{{ text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref } from 'vue';
  import AuthService from '../../services/auth';
  import { Modal } from 'bootstrap';

  export default defineComponent({
    setup() {
      const user = ref({
        current_password: '',
        new_password: '',
      });
      const text = ref(null);

      const setPassword = () => {
        AuthService.setPassword(user.value)
          .then((response) => {
            text.value = 'Ваш пароль успешно обновлен';
            return Promise.resolve(response);
          })
          .catch((error) => {
            if (error.response.data.email[0] === 'Пользователь with this Электронная почта already exists.') {
              alert('Пользватель с такой почтой уже зарегестрирован');
            }
            return Promise.reject(error);
          });
      };

      return {
        user,
        text,
        setPassword,
      };
    },
  });
</script>
